const NoticeReducers = (
  state = { title: "", content: "", type: "", timer: 0, show: false },
  action
) => {
  switch (action.type) {
    case "notice":
      return action.payload;
    case "clearNotice":
      return { title: "", content: "", type: "", timer: 0, show: false };
    default:
      return state;
  }
};
export default NoticeReducers;
